import React from 'react';
import { browserHistory } from 'react-router';
import GlobalHeader from '../Fragments/GlobalHeader';
import ProductCovers from '../Fragments/ProductCovers';
import PAFLookup from '../Fragments/PAFLookup';
import SubmitButton from '../Fields/SubmitButton';
import CalendarInput from '../Fields/CalendarInput';
import ButtonChoice from '../Fields/ButtonChoice';
import DataProtection           from '../Fragments/DataProtection';


let Quote = require('../Managers/Quote');
let Questions = require('../Managers/Questions');
let ReactGA =       require('react-ga');

let HttpService = require('../Managers/HttpService');
let Config = HttpService.getConfigForHost();

const StartScreen = React.createClass({
    propTypes: {
        params: React.PropTypes.object
    },
    getInitialState() {
        return {
            policy_start: null,
            propertyLengthOwned: 0,
            isManagedByAgent: null,
            showPostcodeRiskModal: false,
            postcodeRiskResponse: null,
            mediumRiskQuestion: false,
            formHasErrors: false,
            errorMessage: 'Please complete all questions on this step to continue.',
            tla: false,
            isValid: false,
            hasError: false,
            errors: null,
            displayErrors: null,
        };
    },

    componentWillMount() {
        ReactGA.initialize('UA-1926380-5');
        // load asn from either route params or query params
        if (this.props.params.asn != undefined && this.props.params.asn != null) {
            Quote.set('asn', this.props.params.asn);
        }

        if (this.props.location.query.asn != undefined && this.props.location.query.asn != null) {
            Quote.set('asn', this.props.location.query.asn);
        }

        if (Quote.getCurrentAnswer('include_flood_cover') === 'yes') {
            this.setState({ mediumRiskQuestion: true });
        }
    },

    componentDidMount() {
        $('#digitvalidation').hide(); 
        $('#formerror').hide();
        window.scrollTo(0, 0);
        document.title = 'About your cover';

        // Push event to GA
        ReactGA.event({
            category: 'Landlord Insurance',
            action: 'Step1',
            label: 'Quote Form'
        });
    },

    questionComponents : {},

    /**
     * Callback function: sets state for medium flood risk question if the
     * postcode lookup on risk area returns 'true' for medium flood risk.
     */
    mediumRiskQuestion(v) {
        if (v === true) {
            if (window.localStorage.getItem('jpk') === '2'
                || window.localStorage.getItem('jpk') === '4'
                || window.localStorage.getItem('jpk') === '8'
                || window.localStorage.getItem('spk') === '2'
                || window.localStorage.getItem('spk') === '4'
                || window.localStorage.getItem('spk') === '8'
            ) {
                this.setState({ mediumRiskQuestion: true });
            }
        } else {
            this.setState({ mediumRiskQuestion: false });
        }
    },

    /**
     * Callback function: when changing product, we also need to check if the
     * newly-selected product will need an answer for optional flood cover.
     */
    checkAndUpdateRiskRelatedQuestions() {
        if (window.localStorage.getItem('jpk') !== '2'
            || window.localStorage.getItem('jpk') !== '4'
            || window.localStorage.getItem('jpk') !== '8'
            || window.localStorage.getItem('spk') !== '2'
            || window.localStorage.getItem('spk') !== '4'
            || window.localStorage.getItem('spk') !== '8'
        ) {
            this.setState({ mediumRiskQuestion: false });
        }
    },

    getUnansweredQuestions() {
        let unansweredQuestions = [];
        let fields = [
            {
                'field':'need_building_insurance',
                'title':'Please select your type of cover'
            },
            {
                'field':'need_contents_insurance',
                'title':'Please select your type of cover'
            },
            {
                'field':'need_prestige_rent_guarantee',
                'title':'Please select your type of cover'
            },
            {
                'field':'need_legal_expenses',
                'title':'Please select your type of cover'
            },
            {
                'field':'policy_start',
                'title':'When would you like your cover to start?'
            },
            {
                'field':'ins_address_line1',
                'title':'Postcode of property to insure?'
            },
            {
                'field':'owned_for',
                'title':'How long have you owned this property?'
            },
            {
                'field':'through_letting_agent',
                'title':'Is your property managed through a letting agent?'
            }
        ];
        fields.map(function(i) {
            if (Quote.getCurrentAnswer(i.field) == null || Quote.getCurrentAnswer(i.field) == '') {
                unansweredQuestions.push(i.title);
            }
        });
        // Delete duplicate results in return due to multiple cover type fields
        return Array.from(new Set(unansweredQuestions));
    },
    
    validateQuestions() {
      
        let contactlength= $('#contact').val().length;
        
        var first = $('#firstname').val();
        var last = $('#lastname').val();
        var email = $('#email').val();
        var contact = $('#contact').val();
        var lettertype='sendQuoteEmail';

        var tempemail =localStorage.getItem("email_address");
        localStorage.setItem("temp_email",tempemail);
        localStorage.setItem("first_name",first);
        localStorage.setItem("last_name",last);
        localStorage.setItem("email_address",email);
        localStorage.setItem("phone_number",contact);
        localStorage.setItem("lettertype",lettertype);
        localStorage.setItem("MarketingPermission",Quote.getCurrentAnswer("dpa_resale_is_allowed"));
         let marketingPermission;
     
       if(Quote.getCurrentAnswer("dpa_phone_post_is_disallowed") ==null && Quote.getCurrentAnswer("dpa_sms_email_is_disallowed")==null){
        marketingPermission= "yes";
       }
       if(Quote.getCurrentAnswer("dpa_phone_post_is_disallowed") =="yes" && Quote.getCurrentAnswer("dpa_sms_email_is_disallowed")==null){
        marketingPermission= "no";
       }
       if(Quote.getCurrentAnswer("dpa_phone_post_is_disallowed") =="yes" && Quote.getCurrentAnswer("dpa_sms_email_is_disallowed")=="no"){
        marketingPermission= "no";
       }
       if(Quote.getCurrentAnswer("dpa_phone_post_is_disallowed") =="no" && Quote.getCurrentAnswer("dpa_sms_email_is_disallowed")=="yes"){
        marketingPermission= "no";
       }
       if(Quote.getCurrentAnswer("dpa_phone_post_is_disallowed") =="no" && Quote.getCurrentAnswer("dpa_sms_email_is_disallowed")==null){
        marketingPermission= "no";
       }
       if(Quote.getCurrentAnswer("dpa_phone_post_is_disallowed") ==null && Quote.getCurrentAnswer("dpa_sms_email_is_disallowed")=="yes"){
        marketingPermission= "no";
       }
       if(Quote.getCurrentAnswer("dpa_phone_post_is_disallowed") ==null && Quote.getCurrentAnswer("dpa_sms_email_is_disallowed")=="no"){
        marketingPermission= "no";
       }
       if(Quote.getCurrentAnswer("dpa_phone_post_is_disallowed") =="yes" && Quote.getCurrentAnswer("dpa_sms_email_is_disallowed")=="yes"){
        marketingPermission= "no";
       }
       if(Quote.getCurrentAnswer("dpa_phone_post_is_disallowed") =="no" && Quote.getCurrentAnswer("dpa_sms_email_is_disallowed")=="no"){
        marketingPermission= "yes";
       }
       
    

      
      
        
        Quote.set("email_address", localStorage.getItem("email_address"));



        if(localStorage.getItem("first_name")=="" || localStorage.getItem("last_name")=="" || localStorage.getItem('email_address') =="" || localStorage.getItem('phone_number')=="" || contactlength <11){
            $('#formerror').show();
        }else{
            $('#formerror').hide();
        }

        var data = {
            fname: first, 
            lname: last,
            email : email,
            contact : contact,
            lettertype:lettertype,
            marketingPermission:marketingPermission
        };
        // console.log(tempemail);
        // console.log(localStorage.getItem("mailsent"));
        // console.log(localStorage.getItem("email_address"));
       

        if((localStorage.getItem("mailsent") == null || localStorage.getItem("email_address") != tempemail) && localStorage.getItem("movedback") == null && first !="" &&  email!="" && contact!="" && contactlength >=11){ 
        $.ajax({
         url: Config.api.sendEmail.url,
           type: "POST",
            data:data,
            beforeSend: function(jqXHR, settings) {
              console.log(settings.url);
            },
            success: function(data) {
                localStorage.setItem("mailsent","true");
                console.log(data);
               
            },
           
            error: function(data) {
                localStorage.setItem("mailsent","true");
                console.log(data);
                
            },
           
          });

        }
          
        let components = [];

        Object.keys(this.questionComponents).forEach(key => {
            const c = this.questionComponents[key];
            if (c !== null) {
                components.push(c);
                if (c.getChildComponents) {
                    components.push(...c.getChildComponents());
                }
            }
        });

        const isInvalid = components
            .filter(c => c != null)
            .map(c => c.doValidation())
            .some(c => c === false);

        if (isInvalid) {
            return false;
        }
        if(first !="" && email !="" && contact !="" && contactlength >=11){
            window.localStorage.removeItem('current_step');
            Questions.markStep1();
            browserHistory.push('/questions');
        }else{
            // $("#formerror").show();
            // $('#formerror').text("Please Enter all Your Contact Information details")
        }
    },

    reloadStep() {
        // reset all the child components states
        if (this.questionComponents['policyStart'] != null) {
            this.questionComponents['policyStart'].resetState();
        }
        if (this.questionComponents['postcodeLookup'] != null) {
            this.questionComponents['postcodeLookup'].resetState();
        }
        if (this.questionComponents['ownedFor'] != null) {
            this.questionComponents['ownedFor'].resetState();
        }
        if (this.questionComponents['throughLettingAgent'] != null) {
            this.questionComponents['throughLettingAgent'].resetState();
        }

        if (this.state.mediumRiskQuestion && this.questionComponents['includeFloodCover'] != null) {
            this.questionComponents['includeFloodCover'].resetState();
        }

        // and ensure the DOM itself updates
        this.forceUpdate();
    },

    render() {
        let self = this;
        let displayerrors = [];
        if (this.state.displayErrors !== null) {
            this.state.displayErrors.map(function(questionTitle) {
                displayerrors.push(<li>{questionTitle}</li>);
            }, this);
        }

        return (
            <div>
                <GlobalHeader />
                <div className="container stepless">
                    {this.state.displayErrors !== null ?
                        <div className="container pageValidationErrors">
                            <p>Please answer the following questions:</p>
                            <ul>{displayerrors}</ul>
                        </div>
                    : null }
                </div>
                <ProductCovers
                    reloadStep={this.reloadStep}
                    callBackRiskCheck={this.checkAndUpdateRiskRelatedQuestions}
                    ref={function(component) {
                        self.questionComponents['product_covers'] = component;
                    }}
                />

                <CalendarInput
                    fieldName="policy_start"
                    helpText="Your cover start date must be within the next 45 days."
                    question="When would you like your cover to start?"
                    ref={function(component) {
                        self.questionComponents['policy_start'] = component;
                    }}
                />

                <PAFLookup
                    fieldNamePrefix="ins"
                    pafLookup={true}
                    helpText="This is the address of the property that you want to insure."
                    question="Postcode of property to insure?"
                    mediumRiskQuestion={this.mediumRiskQuestion}
                    ref={function(component) {
                        self.questionComponents['paf_lookup'] = component;
                    }}
                />

                <ButtonChoice
                    questionId={0}
                    fieldName="owned_for"
                    question="How long have you owned this property?"
                    loadCachedValue={true}
                    options={[
                        {
                            option_text: 'Under 1 year',
                            option_value: '1',
                            id: 'under-1-year'
                        },
                        {
                            option_text: '1 year',
                            option_value: '2',
                            id: '1-year'
                        },
                        {
                            option_text: '2 years',
                            option_value: '3',
                            id: '2-years'
                        },
                        {
                            option_text: '3 years',
                            option_value: '4',
                            id: '3-years'
                        },
                        {
                            option_text: 'Over 3 years',
                            option_value: '5',
                            id: 'over-3-years'
                        }
                    ]}
                    ref={function(component) {
                        self.questionComponents['owned_for'] = component;
                    }}
                 />

                <ButtonChoice
                    questionId={0}
                    fieldName="through_letting_agent"
                    loadCachedValue={true}
                    question="Is your property managed through a letting agent?"
                    options={[
                        {
                            option_text: 'Yes',
                            option_value: 'yes'
                        },
                        {
                            option_text: 'No',
                            option_value: 'no'
                        }
                    ]}
                    ref={function(component) {
                        self.questionComponents['through_letting_agent'] = component;
                    }}
                 />
                {/* Badly named field Yes means they do want flood cover. No means they dont want it */}
                {/* Only show if medium risk AND product choices include BCI or B (derived from jpk and spk in localStorage) */}
                {/* {this.state.mediumRiskQuestion === true ?
                    <ButtonChoice
                        questionId={0}
                        fieldName="include_flood_cover"
                        loadCachedValue={true}
                        helpText="You can choose whether you want to include flood cover on your quote. Adding Flood cover will increase the cost of your premium. You can edit this option on the quote summary page"
                        question="Your property is in a flood risk area, would you like flood cover?"
                        options={[
                            {
                                option_text: 'Yes',
                                option_value: 'yes'
                            },
                            {
                                option_text: 'No',
                                option_value: 'no'
                            }
                        ]}
                        ref={function(component) {
                            self.questionComponents['include_flood_cover'] = component;
                        }}
                        refName="tla"
                     />
                 : null } */}
<DataProtection />
                <question-row>
                    <SubmitButton
                        label="Next"
                        onClick={this.validateQuestions}
                    />
                </question-row>
            </div>
        );
    }
});

export default StartScreen;



/** WEBPACK FOOTER **
 ** ./src/components/Screens/StartScreen.js
 **/